import { useMindMapStore } from "@/stores/mindMapStore";
import { getCurrentInstance} from "vue";
const { BlobServiceClient } = require("@azure/storage-blob");

export function useMindMapBlob() {
    let that = getCurrentInstance().proxy;
    const mindMapStore = useMindMapStore();
    const initMindMapBlob = () => {
        if (mindMapStore.mindMapBlobsasurl) {
          const serviceClient = new BlobServiceClient(mindMapStore.mindMapBlobsasurl + "?" + mindMapStore.mindMapBlobSas);
          const containerClient = serviceClient.getContainerClient("");
          mindMapStore.setMindMapBlobContainerClient(containerClient);
        }
      };
      const mindMapUploadFile = (currentFile, noTimeTitle = false, customPath = null) => {
        //跟konvaCanvasUploadFile 相同，之後要再細分資料夾
        let times = new Date().getTime();
        return new Promise((r, j) => {
          let promises = [];
          let targetfilename = customPath ?? (noTimeTitle ? that.currentMindMapInfo?.id + "/" + currentFile.name : that.currentMindMapInfo?.id + "/" + times + currentFile.name);
          let blockBlobClient = mindMapStore.mindMapBlobContainerClient.getBlockBlobClient(targetfilename);
          promises.push(blockBlobClient.uploadBrowserData(currentFile));
  
          Promise.all(promises).then(
            () => {
              let finallink = mindMapStore.mindMapBlobsasurl + targetfilename;
              r({
                url: finallink,
                name: targetfilename,
              });
            },
            (err) => {
              j(err);
            }
          );
        });
      };
      return {
        mindMapStore,
        initMindMapBlob,
        mindMapUploadFile
      };
}